module.exports = __webpack_public_path__ + "static/media/logo.68e21afa.png";